import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdjustmentData } from '../adjustments.types';
import { Select } from '@ngxs/store';
import { MatterMortgagesState } from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import {
	MatterMortgage,
	MatterMortgageWithAssociations,
} from '@models/mortgage';
import { AdjustmentsDispatch } from '@state/matter/adjustments';
import { MatterAdjustmentVtb } from '@models/matter';
import { AdjustmentsSelector } from '@state/matter/adjustments/adjustments.selectors';
import { take } from 'rxjs/operators';
import { cloneDeep } from 'lodash';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CalculateNetAdvance } from '@services/financialTotals/financial-totals.service';

@UntilDestroy()
@Component({
	selector: 'app-vtb-mortgage-dialog',
	templateUrl: './vtb-mortgage-dialog.component.html',
	standalone: false,
})
export class VtbMortgageDialogComponent implements OnInit {
	// ...
	@Select(MatterMortgagesState.getVTBMortgage)
	vtbMortgage$!: Observable<MatterMortgage>;
	@Select(AdjustmentsSelector.vtbMortgageAdjustment)
	vtbMortgageAdjustment$: Observable<MatterAdjustmentVtb>;

	public vtbMortgage: MatterMortgage;

	public vtbMortgageAdjustment: MatterAdjustmentVtb;
	public totalAmount: number;
	constructor(
		@Inject(MAT_DIALOG_DATA) public data: AdjustmentData,
		private adjustmentDispatch: AdjustmentsDispatch,
		private matdialogRef: MatDialogRef<VtbMortgageDialogComponent>,
	) {}

	ngOnInit(): void {
		this.vtbMortgage$.pipe(untilDestroyed(this)).subscribe((mortgage) => {
			this.vtbMortgage = cloneDeep(mortgage);
			this.totalAmount = CalculateNetAdvance(
				mortgage as MatterMortgageWithAssociations,
			).total;
		});

		this.vtbMortgageAdjustment$
			.pipe(take(1))
			.subscribe((vtbMortgageAdjustment) => {
				this.vtbMortgageAdjustment = cloneDeep(vtbMortgageAdjustment);
			});
	}

	onSave(form) {
		if (form.invalid) return;

		if (form.dirty) {
			this.adjustmentDispatch.Set(this.vtbMortgageAdjustment);
		}

		this.matdialogRef.close();
	}
}
